import { ICreateContaPJOnboardingRequest } from '../entities/ICreateContaPJOnboardingRequest'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface ICreateContaPJOnboarding {
  execute(data: ICreateContaPJOnboardingRequest): Promise<void>
}

export default class CreateContaPJOnboardingImpl
  implements ICreateContaPJOnboarding
{
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(data: ICreateContaPJOnboardingRequest): Promise<void> {
    return this.pagamentosRepository.createContaPJOnboarding(data)
  }
}
